import { createApp } from "vue";
import App from "./App.vue";
import { createPinia, setActivePinia } from "pinia";
import { useAuthStore } from "@/stores/authStore";
import VueKeycloak from "@dsb-norge/vue-keycloak-js";
import getEnv from "@/utils/utils";
import vuetify from "@/plugins/vuetify";
import { setupRouter } from "@/router";
import { createPersistedState } from "pinia-plugin-persistedstate";

const app = createApp(App);
const pinia = createPinia();
pinia.use(
  createPersistedState({
    key: (id) => `__persisted__${id}`,
    storage: sessionStorage,
  })
);
app.use(pinia);
app.use(vuetify);

// Install Keycloak plugin
app.use(VueKeycloak, {
  config: {
    url: getEnv("VITE_APP_KEYCLOAK_URL") ?? "",
    realm: getEnv("VITE_APP_KEYCLOAK_REALM") ?? "",
    clientId: getEnv("VITE_APP_KEYCLOAK_CLIENT_ID") ?? "",
  },
  init: {
    onLoad: "login-required",
    checkLoginIframe: false,
  },

  onReady: async (keycloak) => {
    app.config.globalProperties.$keycloak = keycloak;

    keycloak.onTokenExpired = () => {
      console.log("🔁 Token expired – attempting refresh...");
      keycloak.updateToken(0); // try to refresh immediately
    };

    keycloak.onAuthRefreshSuccess = () => {
      console.log("✅ Token auto-refreshed – syncing auth store");
      const authStore = useAuthStore();
      authStore.syncWithKeycloak();
    };

    try {
      setActivePinia(pinia);
      const authStore = useAuthStore();
      await authStore.initialize();

      const router = setupRouter(authStore);
      app.use(router);
      await router.isReady();

      app.mount("#app");
    } catch (err) {
      console.error("❌ App failed to initialize", err);
      app.mount("#app"); // fallback to mount anyway
    }
  },

  onInitError: (err) => {
    console.error("❌ Keycloak failed to initialize", err);
    app.mount("#app");
  },
});
